import { renderCustomHeader } from './renderCustomHeader';

export default renderCustomHeader;
